export async function fetchWebImage(url: string) {
	try {
		const response = await fetch(url);

		return await response.arrayBuffer();
	} catch (err) {
		console.error(err);
		return null;
	}
}

export function isWebImage(url: string) {
	return url.toLowerCase().startsWith('http://') || url.toLowerCase().startsWith('https://');
}
